import React from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Ticks,
} from "chart.js";
import { Radar } from "react-chartjs-2";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export const data = {
  labels: ["Object-Oriented", "Web Dev", "Info Sec", "Game Dev", ["Mobile", "Dev  "], "Database"],
  datasets: [
    {
      label: "# of Votes",
      data: [8, 8, 6, 8, 5, 7],
      backgroundColor: "rgba(48, 213, 200, 0.7)",
      borderColor: "rgba(48, 213, 200, 0.2)",
      borderWidth: 1,
    },
  ],
};

export default function Chart() {
  return (
    <Radar
      data={data}
      options={{
        responsive: true,
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: function(context) {
                let label = 'Confidence: ' + context.parsed.r;     
                return label;
            },
            afterLabel: function(context) {
              let classList = [];
              switch(context.dataIndex) {
                case 0:
                  classList.push([" Prog. Fundamentals Using C"], ["Object Oriented C++"], ["Software Development Using C++"], ["Software II - Java"]);
                  break;
                case 1:
                  classList.push(["Web Programming Principles"], ["Web Prog Tools and Frameworks"], ["Web Prog for Apps and Services"], ["Capstone Project"]);
                  break;
                case 2:
                  classList.push(["Web Application Security Assessment"], ["OWASP JuiceShop"], ["Web Application Penetration Testing"]);
                  break;
                case 3:
                  classList.push(["Game Engine Foundations"], ["Game Maker Studio 2 - Multiple Projects"], ["Unity"], ["Unreal Engine"]);
                  break;
                case 4:
                  classList.push(["Software II - Java"]);
                  break;
                case 5:
                  classList.push(["Database Design Principles"], ["SQL DBASE Design Using Oracle"], ["Capstone Project"]);
                  break;
              }
              return classList;
            }

          }
          },
          legend: {
            display: false,
          },
        },
        scales: {
          r: {
            angleLines: {
              color: "white",
            },
            grid: {
              color: "white",
            },
            pointLabels: {
              color: "white",
              font: {
                weight: "bold",
                size: 15,
              },
            },
            ticks: {
              display: false,
            },
            suggestedMin: 0,
            suggestedMax: 10,
          },
        },
      }}
    />
  );
}
